import { MediaImage } from 'editor/src/store/design/types';

// Stitch data is matched back onto elements by hash, so a frame left without artwork must drop the
// hash too, or a late digitization re-attaches the removed image's stitch count to it.
const clearDigitizationData = (element: Partial<MediaImage>) => {
  element.digitizing_hash = undefined;
  element.stitch_count = undefined;
  element.digitizing = undefined;
};

export default clearDigitizationData;
